export default "__VITE_ASSET__CLrNV3oM__"